export const en = {
    routes: {
        dashboard: "Dashboard",
        meetingRooms: "Meeting Rooms",
        consoleUsers: "Console Users",
        billingReport:"Billing Report",
        consoleUserscreate: "Console User - Create",
        consoleUsersdetails: "Console User - Details",
        meetingRoomscreate: "Meeting Room - Create",
        meetingRoomsdetails: "Meeting Room - Details",
        buildings: "Buildings",
        buildingsdetails: "Building - Details",
        buildingscreate: "Building - Create",
        parking: "Parking List",
        parking_slots: "Parking Slots",
        parking_floors: "Parking Floors",
        calendar: "Calendar",
        personal_area: "Personal Area",
        personalArea: "Personal Area",
        admin: "Admin",
        entities: "Entities",
        entitiescreate: "Entity - Create",
        entitiesdetails: "Entity - Details",
        users: "Users",
        userscreate: "User - Create",
        usersdetails: "User - Details",
        roles: "Roles",
        rolescreate: "Role - Create",
        rolesdetails: "Role - Details",
        rules: "Rules",
        smartBuildings: "Smart Buildings",
        visits: "Visits",
        currentVisits: "Current Visits",
        currentVisitscreate: "Current Visits - Create",
        visitors: "Visitors",
        plannedVisits: "Planned Visits",
        visitsHistoric: "Historic",
        visitorsdetails: "Visitor - Details",
        terminals: "Terminals",
        terminalscreate: "Terminals - Create",
        terminalsdetails: "Terminal Details",
        interfaces: "Interfaces",
        interfacesdetails: "Interface Details",
        interfacesCreate: "Terminal Interface - Create",
        entityInterfacesCreate: "Entity Interface - Create",
        create: "Create",
        parkingList: 'Parkings',
        parkingdetails: 'Parking'
    },
    forms: {
        checkbox: {
            left: "Left",
            center: "Center",
            right: "Right",
            selectAll: "Select All",
            hasSeparator: "Has Line:",
            titlePosition: "Title position:"
        },
        yes: 'Yes',
        no: 'No',
        ok: 'OK',
        cancel: 'Cancel',
        duplicate: 'Duplicate',
        submit: 'Submit',
        save: 'Save',
        clear: 'Clear all',
        edit: 'Edit',
        back: 'Back',
        loading: 'Loading...',
        sendEmail: 'Send Email',
        reset: 'Reset',
        sending: 'Sending...',
        delete: 'Delete',
        create: 'Create',
        errors: {
            emptyRequiredField: 'Field should not be empty',
            invalidEmail: 'Invalid email',
            notAnInteger: 'Invalid integer value'
        }
    },
    email: 'Email',
    password: 'Password',
    repeatPassword: 'Repeat password',
    search: 'Search',
    dataTable: {
        header: {
            numberOfSelectedEntries: "%{numberOfSelectedEntries} selected",
            numberOfElements: {
                itemsRangeAndTotal: "%{firstItemNumber} -  %{lastItemNumber} of %{totalElements} entries",
                singlePage: "%{totalElements} entries",
                singleItem: "1 entry"
            }
        },
        status: {
            active: 'Active',
            inactive: 'Inactive',
            uncertain: 'N/A',
            pending: 'Pending',
            disconnected: 'Disconnected'
        },
        noData: "No data available"
    },
    searchForm: {
        filterPreview: {
            dropdown: '%{numberOfElements} selected'
        }
    },
    fields: {
        imgUploader: {
            uploadImg: "Upload Image",
            placeholder: "Placeholder"
        },
        units: {
            hours: "H",
            minutes: "min"
        }
    },
    subForms: {
        field: {
            capacity: "Capacity",
            image: "Image",
            websiteLink: "Website Link",
            latitude: "Latitude",
            longitude: "Longitude",
            zipCode: "Zip Code",
            address: "Address",
            accessInformation: "Access Information",
            parish: "Parish",
            city: "City",
            country: "Country",
            timezone: "Timezone",
            hasCheckInConfiguration: 'Check-In Control',
            checkInConfiguration: {
                domain: 'Excluded Domains',
                domainPlaceholder: 'Type a domain and press enter',
                enableNotification: 'Notify Invitees',
                autoCheckOutDelay: 'Auto Check-Out Delay',
                operationTimeStart: 'Open Time',
                operationTimeEnd: 'Close Time',
            }
        },
        file: {
            image: "Image",
            placeholder: "Placeholder"
        }
    }
};